module.exports = __webpack_public_path__ + "static/suggestion_obj01@2x-fe88fc8b0ea8a6e409d2190517a7e3e6.png";